<template>
    <div id="benutzerverwaltung">
        <span v-for="user in this.benutzer" :key="user.email">
            <BenutzerObj :userObj="user" @updateBenutzerTable="this.setBenutzer()"/>
        </span>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import BenutzerObj from "@/components/BenutzerObj.vue";
import axios from 'axios'
import {Benutzer} from '@/backend_controller/benutzer.js';

export default {
  name: "BenutzerVerwaltung",
  components: {
    Header,
    Footer,
    BenutzerObj
  },
  props: {
    
  },
  data() {
    return {
      benutzer: [],
    };
  },
  methods: {
    async getBenutzer() {
        var konvKey = this.$route.params.id.replace(":", "");
        return await Benutzer.get(konvKey);
    },
    async setBenutzer(){
      this.benutzer = await this.getBenutzer()
    },
  },
  async created(){
    this.benutzer = await this.getBenutzer();
    //console.log(this.benutzer.data);
  },
  setup() {
    const emits = ['updateBenutzerTable'];
    return { emits };
  }
};
</script>

<style lang="scss">
#benutzerverwaltung{
    margin-top: 5.5rem;
    //max-height: 500px;
    height: 82vh;
    overflow-y: auto;
}

@media screen and (max-height: 768px) {
    #benutzerverwaltung{
      margin-bottom: 10vh;
    }
}
</style>